<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Exports</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close Filter Exports"
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="feature">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 200px;">
        <mat-label>Feature</mat-label>
        <mat-select
          placeholder="Feature"
          [(ngModel)]="dataSource.filter_feature"
          name="feature"
          matTooltip="Filter exports by the feature that produced them.">
          <mat-option value="">All Features</mat-option>
          <mat-option value="tasks">Tasks</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="format">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 150px;">
        <mat-label>Format</mat-label>
        <mat-select
          placeholder="Format"
          [(ngModel)]="dataSource.filter_format"
          name="format"
          matTooltip="Filter exports by file format.">
          <mat-option value="">All Formats</mat-option>
          <mat-option value="csv">CSV</mat-option>
          <mat-option value="xlsx">XLSX</mat-option>
          <mat-option value="pdf">PDF</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 170px;">
        <mat-label>Status</mat-label>
        <mat-select
          placeholder="Status"
          [(ngModel)]="dataSource.filter_status"
          name="status"
          matTooltip="Filter exports by lifecycle status.">
          <mat-option value="">All Statuses</mat-option>
          <mat-option value="queued">Queued</mat-option>
          <mat-option value="processing">Processing</mat-option>
          <mat-option value="completed">Completed</mat-option>
          <mat-option value="failed">Failed</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_filter">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker
        dateRangeTitle="Requested Date Range"
        dateRangePlaceholder="Select Date Range"
        dateRangeTooltip="Filter exports by the date they were requested."
        [dateRangeInput]="dataSource.date_filter_range"
        (dateRangeOutput)="getOutputDateRange($event)">
      </app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="dataSource.date_filter_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
